/**
 * QuoteOperationalStatusBadge — customer-offer lifecycle status (Sprint 8.9).
 */

import React from "react";
import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  getQuoteOperationalBucket,
  getQuoteOperationalLabel,
} from "../services/quoteOperationalStatus.js";

const StyledChip = styled(Chip)({
  fontWeight: 600,
  fontSize: "0.75rem",
  height: "24px",
  "&.qops-draft": {
    backgroundColor: "rgba(158, 158, 158, 0.12)",
    color: "#616161",
    borderColor: "rgba(158, 158, 158, 0.35)",
  },
  "&.qops-ready_to_send": {
    backgroundColor: "rgba(46, 125, 50, 0.12)",
    color: "#2e7d32",
    borderColor: "rgba(46, 125, 50, 0.35)",
  },
  "&.qops-sent": {
    backgroundColor: "rgba(25, 118, 210, 0.12)",
    color: "#1565c0",
    borderColor: "rgba(25, 118, 210, 0.35)",
  },
  "&.qops-viewed": {
    backgroundColor: "rgba(94, 53, 177, 0.12)",
    color: "#5e35b1",
    borderColor: "rgba(94, 53, 177, 0.35)",
  },
  "&.qops-negotiating": {
    backgroundColor: "rgba(0, 151, 167, 0.12)",
    color: "#00838f",
    borderColor: "rgba(0, 151, 167, 0.35)",
  },
  "&.qops-deposit_requested": {
    backgroundColor: "rgba(237, 108, 2, 0.12)",
    color: "#ef6c00",
    borderColor: "rgba(237, 108, 2, 0.35)",
  },
  "&.qops-deposit_received": {
    backgroundColor: "rgba(46, 125, 50, 0.16)",
    color: "#1b5e20",
    borderColor: "rgba(46, 125, 50, 0.4)",
  },
  "&.qops-accepted": {
    backgroundColor: "rgba(56, 142, 60, 0.14)",
    color: "#2e7d32",
    borderColor: "rgba(56, 142, 60, 0.4)",
  },
  "&.qops-expired": {
    backgroundColor: "rgba(158, 158, 158, 0.12)",
    color: "#757575",
    borderColor: "rgba(158, 158, 158, 0.35)",
  },
  "&.qops-superseded": {
    backgroundColor: "rgba(158, 158, 158, 0.12)",
    color: "#757575",
    borderColor: "rgba(158, 158, 158, 0.35)",
  },
  "&.qops-rejected": {
    backgroundColor: "rgba(211, 47, 47, 0.12)",
    color: "#c62828",
    borderColor: "rgba(211, 47, 47, 0.35)",
  },
  "&.qops-ordered": {
    backgroundColor: "rgba(49, 27, 146, 0.14)",
    color: "#311b92",
    borderColor: "rgba(49, 27, 146, 0.4)",
  },
  "&.qops-unknown": {
    backgroundColor: "rgba(158, 158, 158, 0.12)",
    color: "#757575",
    borderColor: "rgba(158, 158, 158, 0.35)",
  },
});

const QuoteOperationalStatusBadge = ({
  quote,
  bucket: bucketProp,
  size = "small",
}) => {
  const bucket = bucketProp || getQuoteOperationalBucket(quote);
  if (!bucket) return null;

  return (
    <StyledChip
      label={getQuoteOperationalLabel(bucket)}
      size={size}
      variant="outlined"
      className={`qops-${bucket}`}
      data-testid="quote-ops-status-badge"
    />
  );
};

export default QuoteOperationalStatusBadge;
